import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ManagePackageLayer from "../components/school/ManagePackageLayer";

const ManagePackagePage = () => {
  return (
    <MasterLayout>
      <ManagePackageLayer />
    </MasterLayout>
  );
};

export default ManagePackagePage;
